import * as profileRoutines from './profileRoutines';
import { connect } from 'react-redux';
import Profile from '../../Components/Profile/Profile';

function mapStateToProps(state) {
    return {};
}

const mapDispatchToProps = {
    toggleProfilePicRequired: profileRoutines.toggleProfilePicRequired,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Profile);
